import { useState, useEffect } from 'react';
import { Flame } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const StreakBadge = ({ className = '', onStreakLoaded }) => {
    const { language } = useLanguage();
    const [streak, setStreak] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchStreak();
    }, []);

    const fetchStreak = async () => {
        try {
            const response = await axios.get(`${API}/streak`);
            setStreak(response.data.current_streak || 0);
            if (onStreakLoaded) {
                onStreakLoaded(response.data);
            }
        } catch (error) {
            console.error('Error fetching streak:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading || streak < 1) return null;

    return (
        <div className={`streak-badge ${className}`} data-testid="streak-badge">
            <Flame className="w-4 h-4 streak-fire" />
            <span>{streak} {language === 'id' ? 'Hari Berturut' : 'Day Streak'}</span>
        </div>
    );
};
